import { useEffect, type ReactNode } from 'react';
import { useThemeStore, resolveColorMode } from '@/stores/themeStore';

/**
 * Tema durumunu <html> üzerindeki attribute'lara ve CSS değişkenlerine yazar.
 *
 * Neden attribute? Çünkü sidebar modu, yön ve renk modu SALT CSS ile
 * yönetiliyor. React'te koşullu ağaç kurmak yerine tek bir attribute
 * değiştirmek hem daha hızlı hem de geçiş animasyonlarını bozmuyor.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useThemeStore();

  useEffect(() => {
    const el = document.documentElement;
    const resolved = resolveColorMode(theme.colorMode);

    el.setAttribute('data-bs-theme', resolved);
    el.setAttribute('dir', theme.direction);
    el.setAttribute('lang', 'tr');
    el.setAttribute('data-nav-layout', theme.navLayout);
    el.setAttribute('data-sidebar', theme.sidebarState);
    el.setAttribute('data-menu-tone', theme.menuTone);
    el.setAttribute('data-header-tone', theme.headerTone);
    el.setAttribute('data-container', theme.containerWidth);
    el.setAttribute('data-density', theme.density);

    el.style.setProperty('--primary-rgb', theme.primaryRgb);
    el.style.setProperty('--primary-strong-rgb', theme.primaryStrongRgb);
  }, [theme]);

  // Kullanıcı "sistem" modundayken işletim sistemi teması değişirse
  // arayüz anında takip etmeli.
  useEffect(() => {
    if (theme.colorMode !== 'system') return;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
      document.documentElement.setAttribute(
        'data-bs-theme',
        mq.matches ? 'dark' : 'light',
      );
    };

    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [theme.colorMode]);

  return <>{children}</>;
}
